function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B48C69"
    },
    d: "M238.345,494.345c0,9.751,7.904,17.655,17.655,17.655l0,0c9.751,0,17.655-7.904,17.655-17.655 V185.379h-35.31V494.345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC69"
    },
    d: "M256,79.448L256,79.448c-9.751,0-17.655,7.904-17.655,17.655v70.621h35.31V97.103 C273.655,87.352,265.751,79.448,256,79.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC69"
    },
    d: "M256,61.793c4.875,0,8.828-3.953,8.828-8.828V8.828C264.828,3.953,260.875,0,256,0 s-8.828,3.953-8.828,8.828v44.138C247.172,57.841,251.125,61.793,256,61.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE68C"
    },
    d: "M344.276,88.276h-44.138c-4.875,0-8.828,3.953-8.828,8.828c0,4.875,3.953,8.828,8.828,8.828h44.138 c4.875,0,8.828-3.953,8.828-8.828C353.103,92.228,349.151,88.276,344.276,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE68C"
    },
    d: "M220.69,97.103c0-4.875-3.953-8.828-8.828-8.828h-44.138c-4.875,0-8.828,3.953-8.828,8.828 c0,4.875,3.953,8.828,8.828,8.828h44.138C216.737,105.931,220.69,101.978,220.69,97.103z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE178"
    },
    d: "M324.662,40.925c3.447-3.447,3.447-9.037,0-12.484s-9.037-3.447-12.484,0l-31.21,31.21 c-3.447,3.447-3.447,9.036,0,12.484c3.447,3.448,9.037,3.447,12.484,0L324.662,40.925z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF0A0"
    },
    d: "M208.205,132.414l-20.868,20.868c-3.447,3.447-3.447,9.037,0,12.484 c3.447,3.447,9.037,3.447,12.484,0l20.868-20.868c3.447-3.447,3.447-9.037,0-12.484 C217.242,128.967,211.652,128.967,208.205,132.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF0A0"
    },
    d: "M303.795,132.414c-3.447-3.447-9.037-3.447-12.484,0c-3.447,3.447-3.447,9.036,0,12.484 l20.867,20.867c3.447,3.447,9.037,3.447,12.484,0l0,0c3.447-3.447,3.447-9.036,0-12.484L303.795,132.414z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE178"
    },
    d: "M199.821,28.441c-3.447-3.447-9.037-3.447-12.484,0c-3.447,3.447-3.447,9.036,0,12.484l31.21,31.21 c3.447,3.447,9.036,3.447,12.484,0c3.447-3.447,3.447-9.036,0-12.484L199.821,28.441z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.345,
    y: 167.724,
    style: {
      fill: "#A07855"
    },
    width: 35.31,
    height: 17.655
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM3);
export default __webpack_public_path__ + "static/media/m3.051c49347ecdccacb0c2b0fa80e20ee7.svg";
export { ForwardRef as ReactComponent };